import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { Roles } from '../../model/Roles';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-not-authorized',
  templateUrl: './not-authorized.component.html',
  styleUrls: ['./not-authorized.component.scss']
})
export class NotAuthorizedComponent {

  constructor(
    private router: Router,
    private authService: AuthService
    ) { 
      this.brand = environment.brand;
    }

    brand:string;

  homePage(){
    if(this.authService.hasRole(Roles.PortalUser)){
      this.router.navigate(['.']);
      return;
    }

    if(this.authService.hasRole(Roles.MobileAppUser)){
      this.router.navigate(['./mobileCenter']);
      return;
    }

    if(this.authService.hasRole(Roles.WorkshopUser)){
      this.router.navigate(['./workshopCenter']);
      return;
    }

    if(this.authService.hasRole(Roles.DealerUser)){
      this.router.navigate(['./DealerCenter']);
      return;
    }

     if(this.authService.hasRole(Roles.PartsSupplierUser)){
      this.router.navigate(['./PartsSupplierCenter']);
      return;
    }
    
  }

  logout(){
    this.authService.logout();
  }

}
